// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__3Lh_i","inputWrap":"Table_inputWrap__1rRTq","col":"Table_col__3ocMa","bmiTooltip":"Table_bmiTooltip__2nWk_"};